// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20PEp","tabsBox":"styles_tabsBox__1b_xa","createButton":"styles_createButton__29Ehl"};